import React from "react";
import * as yup from "yup";
import VVSSelectModel from "components/form-control/VVSSelectModel";
import SelectConst from "components/form-control/SelectConst";
import InputField from "components/form-control/InputField";
import { formatNumber, translateAccount } from "helpers/erp_helper";
import BagdeStatus from "components/Common/BagdeStatus";
import FileAttachments from "components/Common/FileAttachments";
import httpService from "services/httpService";
import CheckBox from "components/form-control/CheckBox";
import moment from "moment";
import { language_vn } from "helpers/language_vn";
import vi from "moment/locale/vi";

const language = language_vn;

const MODEL_CONFIG = {
  Appointment: {
    include: ["customer"],
    routingField: "objectId",
    columns: [
      {
        text: "Người yêu cầu",
        type: "model",
        field: "customer.fullName",
        modelNames: ["Customer"],
      },
      {
        text: "Số điện thoại",
        type: "string",
        field: "customer.phone",
      },
      {
        text: "Số vàng",
        type: "number",
        field: "quanlityOfGoldForSale",
        formatter: cell => (cell ? cell + "chỉ" : ""),
      },
      {
        text: "Phương thức",
        type: "string",
        field: "paymentMethod",
        searchOptions: "transactionGold",
      },
      {
        text: "Thời gian/địa điểm",
        type: "string",
        field: "scheduledTime",
        formatter: cell => cell && moment(cell.iso).format("DD-MM-YYYY"),
      },
      {
        text: "Phản hồi yêu cầu",
        type: "string",
        field: "status",
        formatter: cell => <BagdeStatus titleBadge={cell} typeBadge={cell} />,
      },
    ],
  },
  Branch: {
    routingField: "objectId",
    columns: [
      {
        text: "Tên Chi nhánh",
        field: "name",
        type: "string",
      },
      {
        text: "Địa chỉ",
        field: "address.location",
        type: "string",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => {
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          );
        },
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-YYYY, HH:mm"),
      },
    ],
  },
  Customer: {
    include: ["accounts", "user", "salesTeam", "salesStaff"],
    routingField: "objectId",
    columns: [
      {
        text: "Mã KH",
        field: "code",
        type: "string",
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
      },
      {
        text: "Xác thực",
        field: "user.status",
        type: "boolean",
        formatter: cell => {
          const isVerified = cell === "verifying" || cell === "verified";
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: isVerified ? "green" : "white",
              }}
              disabled
              checked={isVerified}
            />
          );
        },
      },
      {
        text: "Tổng tiền đầu tư",
        field: "totalInvestment",
        type: "string",
        formatter: cell => <span>{cell ? formatNumber(cell) : 0}</span>,
      },
      {
        text: "Sale hỗ trợ",
        type: "model",
        field: "salesStaff.fullName",
        modelNames: ["Employee"],
      },
      {
        text: "Đội sales",
        type: "model",
        field: "salesTeam.name",
        modelNames: ["EmployeeGroup"],
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
        disableSearch: true,
      },
    ],
  },

  CustomerGroup: {
    include: ["accounts", "user"],
    routingField: "objectId",
    columns: [
      {
        text: "Tên nhóm",
        field: "name",
        type: "string",
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },

  Investment: {
    modelName: "Customer",
    include: ["accounts", "user"],
    routingField: "objectId",
    columns: [
      {
        text: "Mã KH",
        field: "code",
        type: "string",
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
      },
      {
        text: "Xác thực",
        field: "user.status",
        type: "boolean",
        formatter: cell => {
          const isVerified = cell === "verifying" || cell === "verified";
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: isVerified ? "green" : "white",
              }}
              disabled
              checked={isVerified}
            />
          );
        },
      },
      {
        text: "Tổng tiền đầu tư",
        field: "totalInvestment",
        type: "string",
        formatter: cell => formatNumber(cell),
        disableSearch: true,
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
        disableSearch: true,
      },
    ],
  },
  Post: {
    routingField: "objectId",
    include: ["category", "createdBy"],
    columns: [
      {
        text: "Tiêu đề",
        field: "title",
        type: "string",
      },
      {
        text: "Danh mục",
        field: "category.Code",
        type: "model",
        modelNames: ["SysCfg"],
      },
      {
        text: "Người tạo",
        field: "createdBy.fullName",
        type: "string",
        disableSearch: true,
      },
      {
        text: "Đăng bài",
        field: "status",
        type: "string",
        formatter: cell => (
          <div className="form-check form-check-success d-flex justify-content-center p-0">
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell === "Publish" ? "green" : "white",
              }}
              disabled
              checked={cell === "Publish"}
            />
          </div>
        ),
        disableSearch: true,
      },
      {
        text: "Thông báo trên app",
        field: "sendPushNotification",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success d-flex justify-content-center p-0">
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
    ],
  },
  Order: {
    include: ["customer"],
    routingField: ["code"],
    columns: [
      {
        text: "Mã đơn",
        field: "code",
        type: "string",
      },
      {
        text: "Tổng tiền",
        field: "total",
        type: "number",
        formatter: cell => formatNumber(cell),
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "orderStatus",
        formatter: cell => <BagdeStatus titleBadge={cell} typeBadge={cell} />,
      },
      {
        text: "Thanh toán",
        field: "paymentMethod",
        type: "string",
        searchOptions: "paymentMethod",
      },
      {
        text: "Ngày đặt hàng",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
    ],
  },
  CustomerAccount: {
    modelName: "Account",
    include: ["bank"],
    columns: [
      {
        text: "Mã tài khoản",
        field: "objectId",
        sort: true,
        type: "string",
      },
      {
        text: "Số tài khoản",
        field: "accountNumber",
        sort: true,
        type: "string",
      },
      {
        text: "Tên tài khoản",
        field: "name",
        sort: true,
        type: "string",
      },
      {
        text: "Ngân hàng",
        field: "bank.Name",
        sort: true,
        type: "model",
        modelNames: ["SysCfg"],
      },
      {
        text: "Ngày liên kết",
        field: "createdAt",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD-MM-YYYY")}</span>,
      },
    ],
  },
  CustomerOrder: {
    modelName: "Order",
    routingPath: "/order/code",
    columns: [
      {
        text: "Mã đơn hàng",
        field: "code",
        type: "string",
      },
      {
        text: "Sản phẩm",
        field: "orderItems",
        formatter: cell => (
          <span>
            {_.truncate(
              cell.map(p => ` ${p.product};`),
              20
            )}
          </span>
        ),
      },
      {
        text: "Tổng giá trị",
        field: "total",
        formatter: cell => <span>{formatNumber(cell)} VND</span>,
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        formatter: cell => <BagdeStatus titleBadge={cell} typeBadge={cell} />,
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("YYYY-MM-DD HH:mm")}</span>
        ),
        sort: true,
      },
    ],
  },
  CustomerTransaction: {
    include: ["target", "source"],
    modelName: "Transaction",
    routingPath: "/transaction/code",
    columns: [
      {
        text: "Mã GD",
        field: "code",
        type: "string",
      },
      {
        text: "Loại GD",
        field: "type",
        type: "string",
        formatter: cell => (
          <span>
            {cell === "pay"
              ? "Thanh toán"
              : cell === "deposit"
              ? "Nạp tiền"
              : cell === "interest"
              ? "Lãi"
              : cell === "withdraw"
              ? "Rút tiền"
              : cell === "refund"
              ? "Rút tiền gốc"
              : cell}
          </span>
        ),
      },
      {
        text: "Số tiền",
        field: "amount",
        type: "string",
        formatter: cell => <span>{formatNumber(Math.abs(cell))} VND</span>,
      },
      {
        text: "Tài khoản nhận",
        field: "target.type",
        type: "string",
        formatter: cell => (
          <span>
            {cell === "wallet" ? "Ví" : cell === "bank" ? "Ngân hàng" : cell}
          </span>
        ),
      },
      {
        text: "Nội dung",
        field: "memo",
        type: "string",
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "requested"
                ? language.requested
                : cell === "completed"
                ? language.completed
                : cell === "canceled"
                ? language.canceled
                : cell
            }
            typeBadge={cell}
          />
        ),
      },
      {
        text: "Ngày giao dịch",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("HH:mm DD-MM-YYYY ")}</span>
        ),
      },
    ],
  },

  TransactionInterest: {
    include: ["target", "source", "contract"],
    modelName: "Transaction",
    routingPath: "/transaction/code",
    columns: [
      {
        text: "Mã GD",
        field: "code",
        type: "string",
      },
      {
        text: "Loại GD",
        field: "type",
        type: "string",
        formatter: cell => (
          <span>
            {cell === "pay"
              ? "Thanh toán"
              : cell === "deposit"
              ? "Nạp tiền"
              : cell === "interest"
              ? "Lãi"
              : cell === "withdraw"
              ? "Rút tiền"
              : cell === "refund"
              ? "Rút tiền gốc"
              : cell}
          </span>
        ),
        disableSearch: true,
      },
      {
        text: "Số tiền",
        field: "amount",
        type: "string",
        formatter: cell => <span>{formatNumber(Math.abs(cell))} VND</span>,
      },
      {
        text: "Tài khoản nhận",
        field: "target.type",
        type: "string",
        formatter: cell => (
          <span>
            {cell === "wallet" ? "Ví" : cell === "bank" ? "Ngân hàng" : cell}
          </span>
        ),
      },
      {
        text: "Nội dung",
        field: "memo",
        type: "string",
      },
      {
        text: "Mã HĐ",
        field: "contract.code",
        type: "string",
        modelNames: ["Contract"],
        type: "model",
      },
      {
        text: "Tên khách hàng",
        field: "customerName",
        type: "string",
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "requested"
                ? language.requested
                : cell === "completed"
                ? language.completed
                : cell === "canceled"
                ? language.canceled
                : cell
            }
            typeBadge={cell}
          />
        ),
        disableSearch: true,
      },
      {
        text: "Ngày giao dịch",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("HH:mm DD-MM-YYYY ")}</span>
        ),
      },
    ],
  },
  CustomerContract: {
    modelName: "Contract",
    routingPath: "/contract/code",
    columns: [
      {
        text: "Mã hợp đồng",
        field: "code",
        sort: true,
        type: "string",
      },
      {
        text: "Số kỳ",
        field: "noPeriods",
        sort: true,
        type: "string",
      },
      {
        text: "Lãi suất",
        field: "rate",
        sort: true,
        type: "string",
        formatter: cell => <span>{cell}% / năm</span>,
        disableSearch: true,
      },
      {
        text: "Tổng giá trị",
        field: "total",
        sort: true,
        type: "string",
        formatter: cell => <span>{formatNumber(cell)} VND</span>,
        disableSearch: true,
      },
      {
        text: "Trạng thái",
        field: "status",
        sort: true,
        type: "string",
        formatter: cell => (
          <BagdeStatus
            typeBadge={cell}
            titleBadge={
              cell === "effective"
                ? "Đang Hiệu Lực"
                : cell === "completed"
                ? "Đã thanh lý"
                : cell === "early-settled"
                ? "Đã tất toán sớm"
                : cell === "pending"
                ? "Đang xử lý"
                : cell === "canceled"
                ? "Đã huỷ"
                : ""
            }
          />
        ),
        searchOptions: "contractStatus",
      },
      {
        text: "Ngày bắt đầu",
        field: "startDate",
        sort: true,
        formatter: cell => (
          <span>{moment(cell?.iso).format("DD-MM-YYYY")}</span>
        ),
      },
      {
        text: "Ngày kết thúc",
        field: "endDate",
        sort: true,
        formatter: cell => (
          <span>{moment(cell?.iso).format("DD-MM-YYYY")}</span>
        ),
      },
    ],
  },
  OrderItem: {
    include: ["product"],
    columns: [
      {
        text: "Mã SP",
        field: "product.barcode",
        type: "string",
        modelNames: ["Product"],
        type: "model",
      },
      {
        text: "Hình ảnh",
        field: "product.image.url",
        type: "string",
        formatter: cell => (
          <img src={cell || ""} style={{ objectFit: "cover", width: "64px" }} />
        ),
      },
      {
        text: "Sản phẩm",
        field: "name",
        type: "string",
      },
      {
        text: "Tiền công",
        field: "product.serviceFee",
        type: "number",
        formatter: cell => formatNumber(cell),
        textAlign: "right",
      },
      {
        text: "Đơn giá",
        field: "sellingPrice",
        type: "number",
        formatter: cell => formatNumber(cell),
        textAlign: "right",
      },
      {
        text: "Số lượng",
        field: "quantity",
        type: "number",
        textAlign: "center",
      },
      {
        text: "Thành tiền",
        field: "total",
        type: "number",
        textAlign: "right",
        formatter: cell => formatNumber(cell),
      },
    ],
  },
  Transaction: {
    include: [
      "order",
      "target.bank",
      "target.customer",
      "customer",
      "source.bank",
    ],
    routingField: "code",
    columns: [
      {
        text: "Mã giao dịch",
        type: "string",
        field: "code",
      },
      {
        text: "Số tiền",
        type: "number",
        field: "amount",
        formatter: cell => formatNumber(Math.abs(cell)),
      },
      {
        text: "Loại giao dịch",
        type: "string",
        field: "type",
        searchOptions: "transactionMoney",
        disableSearch: true,
        formatter: cell => (
          <span>
            {cell === "pay"
              ? "Thanh toán"
              : cell === "deposit"
              ? "Nạp tiền"
              : cell === "interest"
              ? "Lãi"
              : cell === "withdraw"
              ? "Rút tiền"
              : cell === "refund"
              ? "Rút tiền gốc"
              : cell}
          </span>
        ),
      },
      {
        text: "Trạng thái",
        type: "string",
        field: "status",
        searchOptions: "transactionStatus",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "requested"
                ? language.requested
                : cell === "completed"
                ? language.completed
                : cell === "canceled"
                ? language.canceled
                : cell
            }
            typeBadge={cell}
          />
        ),
      },
      {
        text: "Tên khách hàng",
        type: "model",
        field: "customer.fullName",
        modelNames: ["Customer"],
      },
      {
        text: "Tài khoản đích",
        type: "model",
        field: "target",
        modelNames: ["Account"],
        formatter: cell => translateAccount(cell),
        disableSearch: true,
      },

      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        disableSearch: true,
        formatter: cell => (
          <span>{moment(cell).locale("vi", vi).format("DD/MM/YYYY")}</span>
        ),
      },
    ],
  },
  TransactionContract: {
    modelName: "Transaction",
    include: [
      "order",
      "target.bank",
      "target.customer",
      "customer",
      "source.bank",
    ],
    routingField: "code",
    columns: [
      {
        text: "Nội dung",
        type: "string",
        field: "memo",
      },
      {
        text: "Số tiền",
        type: "number",
        field: "amount",
        formatter: cell => formatNumber(Math.abs(cell)),
      },
      {
        text: "Mã giao dịch",
        type: "string",
        field: "code",
      },
      {
        text: "Phương thức",
        type: "string",
        field: "type",
        formatter: cell => (
          <span>
            {cell === "pay"
              ? "Thanh toán"
              : cell === "deposit"
              ? "Nạp tiền"
              : cell === "interest"
              ? "Lãi"
              : cell === "withdraw"
              ? "Rút tiền"
              : cell === "refund"
              ? "Rút tiền gốc"
              : cell}
          </span>
        ),
      },
      {
        text: "Trạng thái",
        type: "string",
        field: "status",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "requested"
                ? language.requested
                : cell === "completed"
                ? language.completed
                : cell
            }
            typeBadge={cell}
          />
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => (
          <span>{moment(cell).locale("vi", vi).format("DD/MM/YYYY")}</span>
        ),
      },
    ],
  },
  Department: {
    routingField: "objectId",
    include: ["leader", "branch"],
    columns: [
      {
        text: "Tên bộ phận",
        type: "string",
        field: "name",
      },
      {
        text: "Leader",
        field: "leader.fullName",
        type: "model",
        modelNames: "Employee",
      },
      {
        text: "Thuộc chi nhánh",
        field: "branch.name",
        type: "model",
        modelNames: "Branch",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },
  Bank: {
    routingField: "objectId",
    modelName: "SysCfg",
    columns: [
      {
        text: "Tên ngân hàng",
        type: "string",
        field: "vn_name",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Tên viết gọn",
        type: "string",
        field: "Name",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
  },
  PostCategory: {
    modelName: "SysCfg",
    columns: [
      {
        text: "Tên danh mục",
        type: "string",
        field: "Name",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
  },
  QuestionCategory: {
    modelName: "SysCfg",
    columns: [
      {
        text: "Mã chủ đề",
        type: "string",
        field: "objectId",
        disableSort: true,
      },
      {
        text: "Tên chủ đề",
        type: "string",
        field: "Name",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
        disableSort: true,
      },
      {
        text: "Số thứ tự hiển thị",
        type: "string",
        field: "value",
        disableSort: true,
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
  },
  Fee: {
    modelName: "SysCfg",
    columns: [
      {
        text: "Mã",
        type: "string",
        field: "serriesCode",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Loại",
        type: "string",
        field: "type",
        searchOptions: "typeFee",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "typeFee",
          }),
        },
      },
      {
        text: "Tối thiểu",
        type: "number",
        field: "valueFrom",
        formatter: cell => formatNumber(cell),
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Tối đa",
        type: "number",
        field: "valueTo",
        formatter: cell => formatNumber(cell),
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      // {
      //   text: "Tiền phí",
      //   type: "number",
      //   field: "fee",
      //   formatter: cell => formatNumber(cell),
      //   editInlineOptions: {
      //     cellComponent: InputField,
      //     cellComponentProps: (row, watch=null) => ({}),
      //   },
      // },
      {
        text: "Số lần",
        type: "number",
        field: "numberOfTransaction",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Trạng thái",
        type: "boolean",
        field: "isActive",
        formatter: cell => {
          return cell ? (
            <BagdeStatus titleBadge={"active"} typeBadge={"active"} />
          ) : (
            <BagdeStatus titleBadge={"inactive"} typeBadge={"inactive"} />
          );
        },
        searchOptions: "statusFee",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "statusFee",
          }),
        },
      },
      {
        text: "Ngày tạo",
        type: "string",
        field: "createdAt",
        formatter: cell => moment(cell).format("DD-MM-YYYY"),
        hiddenInEditMode: true,
      },
    ],
    validationSchema: yup.object().shape({
      SysCfg: yup.array().of(
        yup.object().shape({
          serriesCode: yup.string().required("Yêu cầu nhập mã ID"),
          type: yup.string().required("Yêu cầu chọn loại"),
          valueFrom: yup.number().typeError("Yêu cầu nhập giá"),
          valueTo: yup.number().typeError("Yêu cầu nhập giá"),
          fee: yup.number().typeError("Yêu cầu phí"),
          numberOfTransaction: yup.number().typeError("Yêu cầu nhập số lần"),
        })
      ),
    }),
  },
  Product: {
    routingField: "objectId",
    include: ["category"],
    columns: [
      {
        text: "Mã sản phẩm",
        field: "productId",
        type: "string",
      },
      {
        text: "Tên sản phẩm",
        field: "name",
        type: "string",
      },
      {
        text: "Giá",
        field: "sellingPrice",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VND</span>,
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Tên danh mục",
        type: "model",
        field: "category.name",
        modelNames: ["Category"],
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        formatter: cell => <BagdeStatus titleBadge={cell} typeBadge={cell} />,
      },
      {
        text: "Barcode",
        field: "barcode",
        type: "string",
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-YYYY"),
      },
    ],
  },
  ProductVariance: {
    columns: [
      {
        text: "Màu sắc",
        field: "color",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: row => ({}),
        },
      },
      {
        text: "Kích thước",
        field: "size",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: row => ({}),
        },
      },
      {
        text: "Khối lượng vàng (chỉ)",
        field: "goldWeight",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({
            onFocus: async e => {
              const { setValue, getValues } = formProps;

              if (getValues(`${rowName}.goldWeight`)) return;

              const url = "/parse/classes/GoldWeight";
              const response = await httpService.get(url);
              const weightData = response.results[0];
              const updatedAt = new Date(weightData.updatedAt);
              const diffMs = Date.now() - updatedAt;
              const diffMins = Math.round(
                ((diffMs % 86400000) % 3600000) / 60000
              );
              if (diffMins < 10) {
                setValue(
                  `${rowName}.goldWeight`,
                  Number(weightData.value) * 10
                );
              }
            },
          }),
        },
      },
      {
        text: "Khối lượng đá (chỉ)",
        field: "stoneWeight",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({
            onFocus: async e => {
              const { setValue, getValues } = formProps;

              if (getValues(`${rowName}.stoneWeight`)) return;

              const url = "/parse/classes/GoldWeight";
              const response = await httpService.get(url);
              const weightData = response.results[0];
              const updatedAt = new Date(weightData.updatedAt);
              const diffMs = Date.now() - updatedAt;
              const diffMins = Math.round(
                ((diffMs % 86400000) % 3600000) / 60000
              );
              if (diffMins < 10) {
                setValue(
                  `${rowName}.stoneWeight`,
                  Number(weightData.value) * 10
                );
              }
            },
          }),
        },
      },
      {
        text: "Khối lượng tổng (chỉ)",
        field: "totalWeight",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({
            onFocus: async e => {
              const { setValue, getValues } = formProps;

              if (getValues(`${rowName}.totalWeight`)) return;

              const url = "/parse/classes/GoldWeight";
              const response = await httpService.get(url);
              const weightData = response.results[0];
              const updatedAt = new Date(weightData.updatedAt);
              const diffMs = Date.now() - updatedAt;
              const diffMins = Math.round(
                ((diffMs % 86400000) % 3600000) / 60000
              );
              if (diffMins < 10) {
                setValue(
                  `${rowName}.totalWeight`,
                  Number(weightData.value) * 10
                );
              }
            },
          }),
        },
      },
    ],
  },
  Category: {
    routingField: "objectId",
    columns: [
      {
        text: "Tên danh mục",
        field: "name",
        type: "string",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <BagdeStatus
            titleBadge={cell ? "Active" : "Inactive"}
            typeBadge={cell ? "Active" : "Inactive"}
          />
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-YYYY"),
      },
    ],
  },
  Voucher: {
    routingField: "objectId",
    include: ["campaign"],
    columns: [
      {
        text: "Mã Voucher",
        field: "code",
        type: "string",
      },
      {
        text: "Tên Voucher",
        field: "name",
        type: "string",
      },
      {
        text: "Ngày bắt đầu",
        field: "startDate.iso",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-YYYY"),
      },
      {
        text: "Ngày kết thúc",
        field: "endDate.iso",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-YYYY"),
      },
      {
        text: "Chương trình",
        type: "model",
        field: "campaign.name",
        modelNames: ["Campaign"],
      },
    ],
  },
  ["import-item"]: {
    include: ["product", "productVariance"],
    modelName: "StockChangeItem",
    columns: [
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Product",
          }),
        },
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      //   formatter: (_, rowValue) => {
      //     const productVariance = rowValue?.productVariance || null;
      //     return formatProductVariance(productVariance);
      //   },
      //   editInlineOptions: {
      //     cellComponent: VVSSelectModel,
      //     cellComponentProps: (formProps, rowName) => {
      //       const { watch } = formProps;
      //       const productId = watch(`${rowName}.product.objectId`);
      //       return {
      //         model: "ProductVariance",
      //         conditionField: {
      //           product: {
      //             __type: "Pointer",
      //             className: "Product",
      //             objectId: productId,
      //           },
      //         },
      //         customizeOptions: [CreateProductVarianceModal],
      //         customizeRender: item => (
      //           <React.Fragment>
      //             <div className="text-wrap fw-bold">
      //               {formatProductVariance(item)}
      //             </div>
      //             <div className="text-wrap">{`Barcode: ${item.barcode}`}</div>
      //           </React.Fragment>
      //         ),
      //       };
      //     },
      //   },
      // },
      {
        text: "Giá nhập",
        field: "importedPrice",
        sort: true,
        type: "number",
        formatter: formatNumber,
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => {
            return {};
          },
        },
      },
      {
        text: "Số lượng",
        sort: true,
        type: "number",
        field: "quantity",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      // {
      //   text: "Tổng",
      //   sort: false,
      //   type: "number",
      //   field: "total",
      // },
    ],
    validationSchema: yup.object().shape({
      StockChangeItem: yup.array().of(
        yup.object().shape({
          product: yup.object().shape({
            name: yup.string().required("Trường này bắt buộc"),
          }),
          // productVariance: yup
          //   .object()
          //   .shape({})
          //   .test(
          //     "hasVariance",
          //     "Sản phẩm có biến thể",
          //     async (value, formContext) => {
          //       const { product } = formContext.parent;
          //       if (!product.objectId || value.objectId) return true;
          //       const url = "/parse/classes/ProductVariance";
          //       const params = {
          //         where: {
          //           product: {
          //             __type: "Pointer",
          //             className: "Product",
          //             objectId: product.objectId,
          //           },
          //         },
          //       };
          //       const response = await httpService.get(url, { params });
          //       if (!response.results.length) return true;
          //       return false;
          //     }
          //   ),
          quantity: yup.number().typeError("Không hợp lệ"),
          // importedPrice: yup.number().typeError("Không hợp lệ"),
        })
      ),
    }),
  },
  import: {
    modelName: "StockChangeSession",
    include: ["branch", "wareHouse", "vendor"],
    columns: [
      {
        text: "Mã phiếu",
        sort: true,
        type: "string",
        field: "code",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        field: "createdAt",
        text: "Ngày tạo",
        sort: true,
        hiddenInEditMode: true,
        formatter: cell => moment(cell).format("yyyy-MM-DD"),
      },
      {
        text: "Nhà cung cấp",
        sort: true,
        type: "model",
        field: "vendor.name",
        modelNames: ["Vendor"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Vendor",
          }),
        },
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "StockSessionStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "StockSessionStatus",
          }),
        },
      },
      // {
      //   text: "Phiếu scan",
      //   field: "scanImage",
      //   type: "file",
      //   hiddenInEditMode: true,
      //   formatter: cell =>
      //     cell ? <FileAttachments attachments={[cell]} disableDelete /> : "",
      // },
    ],
    validationSchema: yup.object().shape({
      StockChangeSession: yup.array().of(
        yup.object().shape({
          code: yup.string().required(),
          status: yup.string().required(),
        })
      ),
    }),
  },
  ["stock-adjustment"]: {
    modelName: "StockChangeSession",
    include: ["wareHouse"],
    columns: [
      {
        text: "Mã phiếu",
        type: "string",
        field: "code",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Ngày tạo",
        type: "string",
        field: "createdAt",
        formatter: cell => moment(cell).format("yyyy-MM-DD"),
        hiddenInEditMode: true,
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "StockSessionStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "StockSessionStatus",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeSession: yup.array().of(yup.object().shape({})),
    }),
  },
  ["stock-adjustment-item"]: {
    modelName: "StockChangeItem",
    include: ["product", "ProductVariance"],
    columns: [
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Product",
          }),
        },
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      //   editInlineOptions: {
      //     cellComponent: VVSSelectModel,
      //     cellComponentProps: (formProps, rowName) => {
      //       const { watch } = formProps;
      //       const productId = watch(`${rowName}.product.objectId`);
      //       return {
      //         model: "ProductVariance",
      //         conditionField: {
      //           product: {
      //             __type: "Pointer",
      //             className: "Product",
      //             objectId: productId,
      //           },
      //         },
      //         customizeOptions: [CreateProductVarianceModal],
      //         customizeRender: item => (
      //           <React.Fragment>
      //             <div className="text-wrap fw-bold">
      //               {formatProductVariance(item)}
      //             </div>
      //             <div className="text-wrap">{`Barcode: ${item.barcode}`}</div>
      //           </React.Fragment>
      //         ),
      //       };
      //     },
      //   },
      // },
      {
        text: "Số lượng thay đổi",
        type: "number",
        field: "quantity",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Lí do",
        type: "string",
        field: "reason",
        searchOptions: "stockAdjustmentReason",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "stockAdjustmentReason",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeItem: yup.array().of(yup.object().shape({})),
    }),
  },
  ["stock-audit"]: {
    modelName: "StockAuditSession",
    include: ["wareHouse"],
    columns: [
      {
        text: "Mã phiếu",
        type: "string",
        field: "code",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Ngày tạo",
        type: "string",
        field: "createdAt",
        formatter: cell => moment(cell).format("yyyy-MM-DD"),
        hiddenInEditMode: true,
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "StockSessionStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "StockSessionStatus",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockAuditSession: yup.array().of(yup.object().shape({})),
    }),
  },
  ["stock-audit-item"]: {
    modelName: "StockAuditItem",
    include: ["product", "ProductVariance"],
    columns: [
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Product",
          }),
        },
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      //   editInlineOptions: {
      //     cellComponent: VVSSelectModel,
      //     cellComponentProps: (formProps, rowName) => {
      //       return {
      //         model: "ProductVariance",
      //         conditionField: {
      //           product: {
      //             __type: "Pointer",
      //             className: "Product",
      //             objectId: watch(`${row}.product.objectId`),
      //           },
      //         },
      //       };
      //     },
      //   },
      // },
      {
        text: "Số lượng tồn kho",
        type: "number",
        field: "expectedQuantity",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => {
            const { setValue, getValues } = formProps;
            return {
              onChange: () =>
                setValue(
                  `${rowName}.difference`,
                  getValues(`${rowName}.expectedQuantity`) -
                    getValues(`${rowName}.actualQuantity`)
                ),
            };
          },
        },
      },
      {
        text: "Số lượng cập nhật",
        type: "number",
        field: "actualQuantity",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => {
            const { setValue, getValues } = formProps;
            return {
              onChange: () =>
                setValue(
                  `${rowName}.difference`,
                  getValues(`${rowName}.expectedQuantity`) -
                    getValues(`${rowName}.actualQuantity`)
                ),
            };
          },
        },
      },

      {
        text: "Chênh lệch",
        type: "number",
        field: "difference",
        hiddenInEditMode: true,
      },
    ],
    validationSchema: yup.object().shape({
      StockAuditItem: yup.array().of(yup.object().shape({})),
    }),
  },
  Contract: {
    include: ["customer", "interestRateRef"],
    routingField: "code",
    columns: [
      {
        text: "Mã HĐ",
        sort: true,
        type: "string",
        field: "code",
      },
      {
        text: "Trạng thái HĐ",
        sort: true,
        type: "string",
        field: "status",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "effective"
                ? "Đang hiệu lực"
                : cell === "completed"
                ? "Đã thanh lý"
                : cell === "early-settled"
                ? "Đã tất toán sớm"
                : cell === "pending"
                ? "Đang xử lý"
                : cell === "canceled"
                ? "Đã huỷ"
                : ""
            }
            typeBadge={cell}
          />
        ),
        disableSearch: true,
      },
      {
        text: "Giá trị HĐ",
        sort: true,
        type: "string",
        field: "total",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
        disableSearch: true,
      },
      {
        text: "Số kỳ",
        sort: true,
        type: "number",
        field: "noPeriods",
        searchOptions: "noPeriodsContract",
        formatter: cell => <span>{cell} tháng</span>,
      },
      {
        text: "Nơi đầu tư",
        sort: true,
        type: "string",
        field: "investment",
      },
      {
        text: "Ngày hết hạn HĐ",
        field: "endDate.iso",
        type: "string",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD/MM/YYYY")}</span>,
        disableSearch: true,
      },
      {
        text: "Họ và tên",
        field: "customer.fullName",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
      {
        text: "SĐT",
        field: "customer.phone",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
    ],
  },
  ContractPeriod: {
    include: [
      "transaction",
      "transaction.target",
      "transaction.source",
      "contract",
    ],
    routingPath: "/transaction/code",
    columns: [
      {
        text: "Nội dung",
        sort: true,
        type: "model",
        field: "transaction.memo",
        modelNames: ["Transaction"],
      },
      {
        text: "Số tiền",
        sort: true,
        type: "model",
        field: "transaction.amount",
        modelNames: ["Transaction"],
        formatter: cell => <>{formatNumber(Math.abs(cell))} VNĐ</>,
      },
      {
        text: "Mã hợp đồng",
        type: "string",
        field: "contract.code",
      },
      {
        text: "Phương thức",
        sort: true,
        type: "model",
        field: "transaction.type",
        modelNames: ["Transaction"],
      },
      {
        text: "Trạng thái",
        sort: true,
        type: "model",
        field: "transaction.status",
        modelNames: ["Transaction"],
      },
      // {
      //   text: "Tài khoản nguồn",
      //   sort: true,
      //   type: "model",
      //   field: "transaction.source.accountNumber",
      //   modelNames: ["Transaction", "Account"],
      // },
      // {
      //   text: "Tài khoản đích",
      //   sort: true,
      //   type: "model",
      //   field: "transaction.target.accountNumber",
      //   modelNames: ["Transaction", "Account"],
      // },
      {
        text: "Ngày giao dịch",
        sort: true,
        type: "date",
        field: "transaction.createdAt",
        modelNames: ["Transaction"],
        formatter: cell => moment(cell).format("DD-mm-yyyy"),
      },
    ],
  },
  export: {
    modelName: "StockChangeSession",
    include: ["wareHouse"],
    columns: [
      {
        text: "Mã phiếu",
        field: "code",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => moment(cell).format("yyyy-MM-DD"),
        hiddenInEditMode: true,
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "StockSessionStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "StockSessionStatus",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeSession: yup.array().of(
        yup.object().shape({
          code: yup.string().required("Trường này bắt buộc"),
          status: yup.string().required("Trường này bắt buộc"),
        })
      ),
    }),
  },
  [`export-item`]: {
    modelName: "StockChangeItem",
    include: ["product", "productVariance"],
    columns: [
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Product",
          }),
        },
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      //   editInlineOptions: {
      //     cellComponent: VVSSelectModel,
      //     cellComponentProps: (formProps, rowName) => {
      //       const { watch } = formProps;
      //       const productId = watch(`${rowName}.product.objectId`);
      //       return {
      //         model: "ProductVariance",
      //         conditionField: {
      //           product: {
      //             __type: "Pointer",
      //             className: "Product",
      //             objectId: productId,
      //           },
      //         },
      //         customizeOptions: [CreateProductVarianceModal],
      //         customizeRender: item => (
      //           <React.Fragment>
      //             <div className="text-wrap fw-bold">
      //               {formatProductVariance(item)}
      //             </div>
      //             <div className="text-wrap">{`Barcode: ${item.barcode}`}</div>
      //           </React.Fragment>
      //         ),
      //       };
      //     },
      //   },
      // },
      {
        text: "Số lượng",
        field: "quantity",
        type: "number",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeItem: yup.array().of(yup.object().shape({})),
    }),
  },
  ["stock-transfer"]: {
    modelName: "StockChangeSession",
    include: ["wareHouse"],
    columns: [
      {
        text: "Mã phiếu",
        field: "code",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => moment(cell).format("yyyy-MM-DD"),
        hiddenInEditMode: true,
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        searchOptions: "StockSessionStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "StockSessionStatus",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeSession: yup.array().of(
        yup.object().shape({
          code: yup.string().required("Trường này bắt buộc"),
          status: yup.string().required("Trường này bắt buộc"),
        })
      ),
    }),
  },
  [`stock-transfer-item`]: {
    modelName: "StockChangeItem",
    include: ["product", "productVariance"],
    columns: [
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Product",
          }),
        },
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      //   editInlineOptions: {
      //     cellComponent: VVSSelectModel,
      //     cellComponentProps: (formProps, rowName) => {
      //       const { watch } = formProps;
      //       const productId = watch(`${rowName}.product.objectId`);
      //       return {
      //         model: "ProductVariance",
      //         conditionField: {
      //           product: {
      //             __type: "Pointer",
      //             className: "Product",
      //             objectId: productId,
      //           },
      //         },

      //         customizeOptions: [CreateProductVarianceModal],
      //         customizeRender: item => (
      //           <React.Fragment>
      //             <div className="text-wrap fw-bold">
      //               {formatProductVariance(item)}
      //             </div>
      //             <div className="text-wrap">{`Barcode: ${item.barcode}`}</div>
      //           </React.Fragment>
      //         ),
      //       };
      //     },
      //   },
      // },
      {
        text: "Số lượng",
        field: "quantity",
        type: "number",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeItem: yup.array().of(yup.object().shape({})),
    }),
  },
  [`stock-report`]: {
    modelName: "StockReport",
    include: ["product", "productVariance"],
    columns: [
      {
        text: "Barcode",
        type: "model",
        field: "product.barcode",
        modelNames: ["Product"],
      },
      {
        text: "Sản phẩm",
        type: "model",
        field: "product.name",
        modelNames: ["Product"],
      },
      // {
      //   text: "Biến thể",
      //   type: "model",
      //   field: "productVariance.barcode",
      //   modelNames: ["ProductVariance"],
      // },
      {
        text: "Số lượng",
        field: "quantity",
        type: "number",
      },
    ],
    validationSchema: yup.object().shape({
      StockChangeItem: yup.array().of(yup.object().shape({})),
    }),
  },
  InterestRate: {
    columns: [
      {
        text: "Số tiền tối thiểu(VND)",
        field: "valueFrom",
        type: "number",
        formatter: cell => formatNumber(cell),
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Số tiền tối đa(VND)",
        field: "valueTo",
        type: "string",
        formatter: cell => formatNumber(cell),
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Lãi suất(%)",
        field: "rate",
        type: "number",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Kỳ hạn",
        field: "noPeriods",
        type: "number",
        formatter: cell => (cell ? cell + " tháng" : ""),
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <BagdeStatus
            titleBadge={cell ? "Active" : "Inactive"}
            typeBadge={cell ? "Active" : "Inactive"}
          />
        ),
        searchOptions: "interestStatus",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "interestStatus",
          }),
        },
      },
    ],
    validationSchema: yup.object().shape({
      InterestRate: yup.array().of(
        yup.object().shape({
          valueFrom: yup.number().typeError("Yêu cầu nhập số"),
          valueTo: yup.string().required("Yêu cầu nhập số"),
          rate: yup.number().typeError("Yêu cầu nhập số"),
          noPeriods: yup.number().typeError("Yêu cầu nhập số"),
          isActive: yup.boolean().typeError("Yêu cầu tình trạng"),
          updatedAt: yup.date().typeError("Yêu cầu chọn ngày"),
        })
      ),
    }),
  },
  TransactionAttachment: {
    include: ["createdBy"],
    columns: [
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
      {
        text: "Người tạo",
        field: "createdBy.username",
        modelNames: ["_User"],
        type: "model",
      },
      {
        text: "File đính kèm",
        field: "attachments",
        type: "array",
        formatter: cell => <FileAttachments attachments={cell} disableDelete />,
      },
      {
        text: "Ghi chú",
        field: "note",
        type: "string",
      },
    ],
  },
  AppointmentAttachment: {
    include: ["createdBy"],
    columns: [
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
      {
        text: "Người tạo",
        field: "createdBy.username",
        modelNames: ["_User"],
        type: "model",
      },
      {
        text: "File đính kèm",
        field: "attachments",
        type: "array",
        formatter: cell => <FileAttachments attachments={cell} disableDelete />,
      },
      {
        text: "Ghi chú",
        field: "note",
        type: "string",
      },
    ],
  },
  ContractAttachment: {
    include: ["createdBy"],
    columns: [
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
      {
        text: "Người tạo",
        field: "createdBy.username",
        modelNames: ["_User"],
        type: "model",
      },
      {
        text: "File đính kèm",
        field: "attachments",
        type: "array",
        formatter: cell => <FileAttachments attachments={cell} disableDelete />,
      },
      {
        text: "Ghi chú",
        field: "note",
        type: "string",
      },
    ],
  },
  Promotion: {
    include: [],
    routingField: "series",
    columns: [
      {
        text: "Mã giảm giá",
        field: "series",
        type: "string",
      },
      {
        text: "Tên",
        field: "name",
        type: "string",
      },
      {
        text: "Loại giảm giá",
        field: "type",
        type: "string",
        searchOptions: "promotionType",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        searchOptions: "promotionStatus",
        formatter: cell => (
          <BagdeStatus
            titleBadge={cell ? "Active" : "Inactive"}
            typeBadge={cell ? "Active" : "Inactive"}
          />
        ),
      },
      {
        text: "Giảm theo %",
        field: "percent",
        type: "number",
        formatter: cell => (cell ? cell + "%" : "0%"),
      },
      {
        text: "Giảm cố định",
        field: "fixed",
        type: "number",
        formatter: cell => (cell ? formatNumber(Number(cell)) : 0),
      },
      {
        text: "Ngày bắt đầu",
        field: "startDate.iso",
        type: "date",
        formatter: cell => moment(cell).format("YYYY-MM-DD"),
      },
      {
        text: "Ngày kết thúc",
        field: "endDate.iso",
        type: "date",
        formatter: cell => moment(cell).format("YYYY-MM-DD"),
      },
    ],
  },
  _User: {
    columns: [
      {
        text: "Tên đăng nhập",
        field: "username",
        type: "string",
      },
      {
        text: "Số điện thoại",
        field: "phone",
        sort: true,
        type: "string",
      },
      {
        text: "Lớp",
        field: "class",
        sort: true,
        type: "string",
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: (cell, row) => {
          return (
            <span>
              {cell
                ? moment(cell).utc().format("DD-MM-YYYY")
                : moment(row.updatedAt).utc().format("DD-MM-YYYY")}
            </span>
          );
        },
        disableSearch: true,
      },
    ],
  },
  AccountAdmin: {
    modelName: "_User",
    routingField: "objectId",
    columns: [
      {
        text: "Tên đăng nhập",
        field: "username",
        type: "string",
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: (cell, row) => {
          return (
            <span>
              {cell
                ? moment(cell).utc().format("DD-MM-YYYY")
                : moment(row.updatedAt).utc().format("DD-MM-YYYY")}
            </span>
          );
        },
        disableSearch: true,
      },
    ],
  },
  Lead: {
    routingField: "objectId",
    include: ["salesStaff", "salesTeam"],
    columns: [
      {
        text: "Họ tên",
        field: "name",
        type: "string",
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
      },
      {
        text: "Email",
        field: "email",
        type: "string",
      },
      {
        text: "Giới tính",
        field: "gender",
        type: "string",
      },
      {
        text: "Nguồn",
        field: "approachFrom",
        type: "string",
      },
      {
        text: "Sale hỗ trợ",
        type: "model",
        field: "salesStaff.fullName",
        modelNames: ["Employee"],
      },
      {
        text: "Đội sales",
        type: "model",
        field: "salesTeam.name",
        modelNames: ["EmployeeGroup"],
      },
      {
        text: "Trạng thái",
        field: "status",
        type: "string",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "Mới"
                ? "Mới"
                : cell === "Mở"
                ? "Mở"
                : cell === "Đã trả lời"
                ? "Đã trả lời"
                : cell === "Cơ hội"
                ? "Cơ hội"
                : cell === "Đã báo giá"
                ? "Đã báo giá"
                : cell === "Báo giá bị mất"
                ? "Báo giá bị mất"
                : cell === "Quan tâm"
                ? "Quan tâm"
                : cell === "Đã chuyển đổi"
                ? "Đã chuyển đổi"
                : cell === "Không nên liên hệ"
                ? "Không nên liên hệ"
                : cell
            }
            typeBadge={cell}
          />
        ),
        searchOptions: "leadStatus",
      },
    ],
  },
  Employee: {
    routingField: "objectId",
    include: ["department", "group"],
    columns: [
      {
        text: "Mã nhân viên",
        field: "employeeId",
        sort: true,
        type: "string",
      },
      {
        text: "Họ tên",
        field: "fullName",
        sort: true,
        type: "string",
      },
      {
        text: "Email",
        field: "email",
        sort: true,
        type: "string",
      },
      {
        text: "Bộ phận",
        type: "model",
        modelNames: ["Department"],
        field: "department.name",
        sort: true,
      },
      {
        text: "Đội nhóm",
        type: "model",
        modelNames: ["EmployeeGroup"],
        field: "group.name",
        sort: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        sort: true,
        formatter: cell => (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          </div>
        ),
      },
    ],
  },
  User: {
    modelName: "_User",
    columns: [
      {
        text: "User name",
        field: "username",
        type: "string",
      },
      {
        text: "phone",
        field: "phone",
        type: "string",
      },
      {
        text: "isActive",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          </div>
        ),
      },
    ],
  },
  Question: {
    modelName: "Question",
    include: ["category"],
    routingField: "objectId",
    columns: [
      {
        text: "Nội dung",
        field: "content",
        type: "string",
      },
      {
        text: "A",
        field: "A",
        type: "string",
      },
      {
        text: "B",
        field: "B",
        type: "string",
      },
      {
        text: "C",
        field: "C",
        type: "string",
      },
      {
        text: "D",
        field: "D",
        type: "string",
      },
      {
        text: "Câu trả lời",
        field: "correctAnswer",
        type: "string",
        formatter: (cell, row) => {
          return <span>{`${cell}`}</span>;
        },
        disableSearch: true,
      },
    ],
  },
  EmployeeUser: {
    modelName: "_User",
    columns: [
      {
        text: "Tên tài khoản",
        field: "fullName",
        type: "string",
      },
      {
        text: "Email",
        field: "email",
        type: "string",
      },
      {
        text: "Role",
        field: "roles",
        type: "string",
        formatter: cell => <span>Staff</span>,
      },
      {
        text: "Status",
        field: "isActive",
        type: "string",
        formatter: cell => (
          <BagdeStatus
            typeBadge={cell ? "Active" : "Inactive"}
            titleBadge={cell ? "Active" : "Inactive"}
          />
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },
  WareHouse: {
    include: ["branch"],
    columns: [
      {
        text: "Tên nhà kho",
        field: "name",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Chi nhánh",
        field: "branch.name",
        type: "model",
        modelNames: ["Branch"],
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Branch",
          }),
        },
      },
      {
        text: "Mặc định cho chi nhánh",
        field: "isBranchDefault",
        type: "boolean",
        formatter: cell => (
          <input
            className="form-check-input"
            type="checkbox"
            style={{
              width: "15px",
              height: "15px",
              borderRadius: "10px",
              border: "1px solid black",
              backgroundColor: cell ? "green" : "white",
            }}
            disabled
            checked={cell}
          />
        ),
        editInlineOptions: {
          cellComponent: CheckBox,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Địa chỉ",
        field: "address",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
  },
  Template: {
    routingField: "objectId",
    columns: [
      {
        text: "Tiêu để mẫu",
        field: "title",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Loại",
        field: "model",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Tên",
        field: "name",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => <span>{moment(cell).format("DD-MM-YYYY")}</span>,
      },
    ],
  },
  Brand: {
    columns: [
      {
        text: "Tên thương hiệu",
        field: "name",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <BagdeStatus
            titleBadge={cell ? "Active" : "Inactive"}
            typeBadge={cell ? "Active" : "Inactive"}
          />
        ),
        searchOptions: "statusBrand",
        editInlineOptions: {
          cellComponent: SelectConst,
          cellComponentProps: (formProps, rowName) => ({
            sysCfgName: "statusBrand",
          }),
        },
      },
    ],
  },
  Vendor: {
    columns: [
      {
        text: "Nhà cung cấp",
        field: "name",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Địa chỉ",
        field: "address",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Số điện thoại",
        field: "phone",
        type: "string",
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
    ],
  },
  EmployeeGroup: {
    routingField: "objectId",
    include: ["leader", "branch", "department"],
    columns: [
      {
        text: "Tên đội nhóm",
        field: "name",
        type: "string",
      },
      {
        text: "Leader",
        field: "leader.fullName",
        type: "model",
        modelNames: "Employee",
      },
      {
        text: "Thuộc chi nhánh",
        field: "branch.name",
        type: "model",
        modelNames: "Branch",
      },
      {
        text: "Bộ phận",
        field: "department.Name",
        type: "model",
        modelNames: "SysCfg",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },
  EmployeeGroupMembers: {
    routingPath: "/employee/objectId",
    include: ["department"],
    modelName: "Employee",
    columns: [
      {
        text: "Mã NV",
        field: "employeeId",
        type: "string",
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Employee",
            configName: "EmployeeMember",
            includeField: ["department"],
            conditionField: {
              position: "employee",
            },
            onSelect: value => {
              if (!value) return;
              const { setValue } = formProps;
              setValue(`${rowName}.fullName`, value.fullName);
              setValue(`${rowName}.email`, value.email);
              setValue(`${rowName}.phone`, value.phone);
              setValue(`${rowName}.isActive`, value.isActive);
              setValue(`${rowName}.position`, value.position);
              setValue(`${rowName}.department`, value.department);
            },
          }),
        },
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
        dependentField: true,
      },
      {
        text: "Bộ phận",
        type: "model",
        field: "department.name",
        modelNames: ["Department"],
        dependentField: true,
      },
      {
        text: "Vị trí",
        field: "position",
        type: "string",
        dependentField: true,
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
        dependentField: true,
      },
      {
        text: "Email",
        field: "email",
        type: "string",
        dependentField: true,
      },
    ],
  },

  CustomerGroupMembers: {
    routingPath: "/customer/objectId",
    include: ["user"],
    modelName: "Customer",
    columns: [
      {
        text: "Mã KH",
        field: "code",
        type: "string",
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Customer",
            configName: "CustomerMember",
            includeField: ["user"],
            onSelect: value => {
              if (!value) return;
              const { setValue } = formProps;
              setValue(`${rowName}.fullName`, value.fullName);
              setValue(`${rowName}.email`, value.email);
              setValue(`${rowName}.phone`, value.phone);
              setValue(`${rowName}.isActive`, value.isActive);
            },
          }),
        },
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
        dependentField: true,
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
        dependentField: true,
      },
      {
        text: "Email",
        field: "email",
        type: "string",
        dependentField: true,
      },
    ],
  },

  DepartmentMembers: {
    routingPath: "/employee/objectId",
    include: ["group"],
    modelName: "Employee",
    columns: [
      {
        text: "Mã NV",
        field: "employeeId",
        type: "string",
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Employee",
            includeField: ["group"],
            conditionField: {
              position: "employee",
            },
            onSelect: value => {
              if (!value) return;
              const { setValue } = formProps;
              setValue(`${rowName}.fullName`, value.fullName);
              setValue(`${rowName}.position`, value.position);
              setValue(`${rowName}.group`, value.group);
              setValue(`${rowName}.phone`, value.phone);
              setValue(`${rowName}.email`, value.email);
              setValue(`${rowName}.isActive`, value.isActive);
            },
          }),
        },
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
        dependentField: true,
      },
      {
        text: "Vị trí",
        field: "position",
        type: "string",
        dependentField: true,
      },
      {
        text: "Đội nhóm",
        type: "model",
        field: "group.name",
        modelNames: ["EmployeeGroup"],
        dependentField: true,
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
        dependentField: true,
      },
      {
        text: "Email",
        field: "email",
        type: "string",
        dependentField: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        searchOptions: "interestStatus",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
        dependentField: true,
      },
    ],
  },
  EmployeeGrade: {
    routingField: "objectId",
    include: ["branch"],
    columns: [
      {
        text: "Tên vị trí",
        field: "name",
        type: "string",
      },
      {
        text: "Thuộc chi nhánh",
        field: "branch.name",
        type: "model",
        modelNames: "Branch",
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },
  EmployeeGradeMembers: {
    routingPath: "/employee/objectId",
    include: ["group"],
    modelName: "Employee",
    columns: [
      {
        text: "Mã NV",
        field: "employeeId",
        type: "string",
        editInlineOptions: {
          cellComponent: VVSSelectModel,
          cellComponentProps: (formProps, rowName) => ({
            model: "Employee",
            configName: "EmployeeMember",
            includeField: ["department"],
            conditionField: {
              position: "employee",
            },
            onSelect: value => {
              if (!value) return;
              const { setValue } = formProps;
              setValue(`${rowName}.fullName`, value.fullName);
              setValue(`${rowName}.group`, value.group);
              setValue(`${rowName}.phone`, value.phone);
              setValue(`${rowName}.email`, value.email);
              setValue(`${rowName}.isActive`, value.isActive);
            },
          }),
        },
      },
      {
        text: "Họ và tên",
        field: "fullName",
        type: "string",
        dependentField: true,
      },
      {
        text: "Đội nhóm",
        type: "model",
        field: "group.name",
        modelNames: ["EmployeeGroup"],
        dependentField: true,
      },
      {
        text: "SĐT",
        field: "phone",
        type: "string",
        dependentField: true,
      },
      {
        text: "Email",
        field: "email",
        type: "string",
        dependentField: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        searchOptions: "interestStatus",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
        dependentField: true,
      },
    ],
  },
  ProductInvestment: {
    modelName: "Product",
    routingField: "objectId",
    columns: [
      {
        text: "Tên gói đầu tư",
        field: "name",
        type: "string",
      },
      {
        text: "Giá trị gói (VNĐ)",
        field: "sellingPrice",
        type: "number",
        formatter: cell => <span>{cell ? `${formatNumber(cell)}` : ""}</span>,
      },

      {
        text: "Trạng thái",
        field: "isActive",
        sort: true,
        formatter: cell => {
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          );
        },
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
      {
        text: "Ngày cập nhật",
        field: "updateAt",
        type: "date",
        formatter: cell => moment(cell).format("DD-MM-yyyy"),
      },
    ],
  },
  Kpi: {
    routingField: "objectId",
    include: ["employeeGrade"],
    columns: [
      {
        text: "Tên KPI",
        field: "name",
        type: "string",
      },
      {
        text: "Doanh số bắt buộc từ",
        field: "requiredSalesFrom",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Doanh số bắt buộc đến",
        field: "requiredSalesTo",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Đối tượng áp dụng",
        type: "model",
        field: "employeeGrade.name",
        modelNames: ["EmployeeGrade"],
        dependentField: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>{moment(cell).format("DD-MM-YYYY HH:mm")}</span>
        ),
      },
    ],
  },

  RefferalBonus: {
    routingField: "objectId",
    include: ["employee", "customer", "isApprovedBy"],
    columns: [
      {
        text: "Khách hàng",
        type: "model",
        field: "customer.fullName",
        modelNames: ["Customer"],
        dependentField: true,
      },
      {
        text: "Tiền thưởng hoa hồng",
        field: "amount",
        formatter: cell => <span>{formatNumber(cell)} VND</span>,
        dependentField: true,
      },
      {
        text: "Trạng thái phê duyệt",
        field: "isApproved",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
        dependentField: true,
      },
      {
        text: "Được phê duyệt bởi",
        type: "model",
        field: "isApprovedBy.fullName",
        modelNames: ["Employee"],
        dependentField: true,
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        sort: true,
        formatter: cell => (
          <span>{moment(cell).locale("vi", vi).format("DD/MM/YYYY")}</span>
        ),
      },
    ],
  },

  ReferralBonusPolicy: {
    routingField: "objectId",
    include: ["department"],
    columns: [
      {
        text: "Giá trị từ",
        field: "valueFrom",
        formatter: cell => <span>{formatNumber(cell)}</span>,
        dependentField: true,
      },
      {
        text: "Giá trị đến",
        field: "valueTo",
        formatter: cell => <span>{formatNumber(cell)}</span>,
        dependentField: true,
      },
      {
        text: "Tiền thưởng",
        field: "bonusAmount",
        dependentField: true,
        formatter: cell => (
          <span>{cell ? `${formatNumber(cell)} VND` : ""}</span>
        ),
      },
      {
        text: "Phần trăm thưởng",
        field: "bonusPercentage",
        dependentField: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
        dependentField: true,
      },
      {
        text: "Áp dụng cho",
        field: "applyFor",
        formatter: cell => (
          <span>{cell === "employee" ? "Nhân viên" : "Khách hàng"}</span>
        ),
        dependentField: true,
      },
      {
        text: "Tiêu chí",
        field: "criteria",
        formatter: cell => (
          <span>
            {cell === "contract"
              ? "Hợp đồng"
              : cell === "sales"
              ? "Doanh số"
              : "Số lượng nhà đầu tư"}
          </span>
        ),
        dependentField: true,
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "string",
        sort: true,
        formatter: cell => (
          <span>{moment(cell).locale("vi", vi).format("DD/MM/YYYY")}</span>
        ),
      },
    ],
  },
  KPIAssignment: {
    routingField: "objectId",
    include: ["kpi", "employee", "team"],
    columns: [
      {
        text: "KPI",
        field: "kpi.name",
        type: "model",
      },
      {
        text: "Doanh thu",
        field: "saleTotal",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Tổng hợp đồng",
        field: "contractTotal",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} HĐ</span>,
      },
      {
        text: "Thưởng KPI",
        field: "bonus",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Nhân viên",
        field: "employee.fullName",
        type: "model",
        modelNames: ["Employee"],
      },
      {
        text: "Đội nhóm",
        field: "team.name",
        type: "model",
        modelNames: ["EmployeeGroup"],
      },
      {
        text: "Ngày bắt đầu",
        field: "from",
        type: "date",
        formatter: cell => <span>{moment(cell.iso).format("DD-MM-YYYY")}</span>,
      },
      {
        text: "Ngày hết hạn",
        field: "to",
        type: "date",
        formatter: cell => <span>{moment(cell.iso).format("DD-MM-YYYY")}</span>,
      },
    ],
  },

  KPIAssignment1: {
    modelName: "KPIAssignment",
    include: ["kpi", "employee", "team"],
    columns: [
      {
        text: "KPI",
        field: "kpi.name",
        type: "model",
      },
      {
        text: "Doanh thu",
        field: "saleTotal",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Tổng hợp đồng",
        field: "contractTotal",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} HĐ</span>,
      },
      {
        text: "Thưởng KPI",
        field: "bonus",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Hoa hồng",
        field: "commision",
        type: "number",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
      },
      {
        text: "Nhân viên",
        field: "employee.fullName",
        type: "model",
        modelNames: ["Employee"],
      },
      {
        text: "Đội nhóm",
        field: "team.name",
        type: "model",
        modelNames: ["EmployeeGroup"],
      },
      {
        text: "Ngày bắt đầu",
        field: "from",
        type: "date",
        formatter: cell => <span>{moment(cell.iso).format("DD-MM-YYYY")}</span>,
      },
      {
        text: "Ngày hết hạn",
        field: "to",
        type: "date",
        formatter: cell => <span>{moment(cell.iso).format("DD-MM-YYYY")}</span>,
      },
    ],
  },

  HistoryCallLog: {
    modelName: "CallLog",
    include: ["customer"],
    columns: [
      {
        text: "Thời gian gọi",
        field: "createdAt",
        type: "date",
        formatter: cell => (
          <span>
            {moment(cell || "")
              .locale("vi", vi)
              .format("DD-MM-YYYY hh:mm A")}
          </span>
        ),
      },
      {
        text: "Tên khách hàng",
        field: "customerName",
        type: "string",
      },
      {
        text: "SĐT khách hàng",
        field: "phone",
        type: "string",
      },
      {
        text: "Thời lượng cuộc gọi",
        field: "duration",
        type: "number",
        formatter: cell => <span>{cell} giây</span>,
        disableSearch: true,
      },
      {
        text: "Loại",
        field: "direction",
        type: "string",
        searchOptions: "historyCallLog",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "Inbound"
                ? "Gọi đến"
                : cell === "Outbound"
                ? "Gọi đi"
                : ""
            }
            typeBadge={cell}
          />
        ),
      },
      {
        text: "Ext",
        field: "ext",
        type: "string",
        disableSearch: true,
      },
      {
        text: "File ghi âm",
        field: "recordedFileUrl",
        type: "string",
        formatter: cell => <a href={cell}>Tải file</a>,
        disableSearch: true,
      },
    ],
  },

  Referral: {
    include: ["inviteCustomer", "referralBonus", "invitedCustomer"],
    columns: [
      {
        text: "Tên khách hàng",
        field: "inviteCustomer.fullName",
        type: "model",
        modelNames: ["Customer"],
      },
      {
        text: "Tên khách hàng đã mời",
        field: "invitedCustomer.fullName",
        type: "model",
        modelNames: ["Customer"],
      },
      {
        text: "Doanh số",
        field: "totalSale",
        type: "string",
      },
      {
        text: "Số hợp đồng",
        field: "totalContract",
        type: "string",
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        formatter: cell => <span>{moment(cell).format("DD-MM-YYYY")}</span>,
      },
    ],
  },
  ExtensionManagement: {
    modelName: "Employee",
    include: ["department"],
    columns: [
      {
        text: "Ext",
        field: "extension",
        type: "string",
        sort: true,
        editInlineOptions: {
          cellComponent: InputField,
          cellComponentProps: (formProps, rowName) => ({}),
        },
      },
      {
        text: "Nhân viên",
        field: "fullName",
        type: "string",
        sort: true,
      },
      {
        text: "Vị trí bộ phận",
        field: "department.name",
        type: "model",
        modelNames: ["Department"],
        sort: true,
      },
      {
        text: "Trạng thái",
        field: "isActive",
        type: "boolean",
        sort: true,

        formatter: cell => (
          <div className="form-check form-check-success">
            <input
              type="checkbox"
              className="form-check-input"
              checked={cell}
              onChange={() => {}}
            />
          </div>
        ),
      },
      {
        text: "Ngày tạo",
        field: "createdAt",
        type: "date",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD/MM/YYYY")}</span>,
      },
      {
        text: "Ngày cập nhật",
        field: "updatedAt",
        type: "date",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD/MM/YYYY")}</span>,
      },
    ],
  },
  LiquidationRequestedContract: {
    routingPath: "/contract/code",
    modelName: "Contract",
    include: ["customer"],
    columns: [
      {
        text: "Mã HĐ",
        sort: true,
        type: "string",
        field: "code",
      },
      {
        text: "Trạng thái HĐ",
        sort: true,
        type: "string",
        field: "status",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "effective"
                ? "Đang hiệu lực"
                : cell === "completed"
                ? "Đã thanh lý"
                : cell === "early-settled"
                ? "Đã tất toán sớm"
                : cell === "pending"
                ? "Đang xử lý"
                : cell === "canceled"
                ? "Đã huỷ"
                : ""
            }
            typeBadge={cell}
          />
        ),
        disableSearch: true,
      },
      {
        text: "Giá trị HĐ",
        sort: true,
        type: "string",
        field: "total",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
        disableSearch: true,
      },
      {
        text: "Số kỳ",
        sort: true,
        type: "string",
        field: "noPeriods",
        formatter: cell => <span>{cell} tháng</span>,
        disableSearch: true,
      },
      {
        text: "Nơi đầu tư",
        sort: true,
        type: "string",
        field: "investment",
      },
      {
        text: "Ngày hết hạn HĐ",
        field: "endDate.iso",
        type: "string",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD/MM/YYYY")}</span>,
        disableSearch: true,
      },
      {
        text: "Họ và tên",
        field: "customer.fullName",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
      {
        text: "SĐT",
        field: "customer.phone",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
    ],
  },
  ExtendContract: {
    routingPath: "/contract/code",
    modelName: "Contract",
    include: ["customer"],
    columns: [
      {
        text: "Mã HĐ",
        sort: true,
        type: "string",
        field: "code",
      },
      {
        text: "Trạng thái HĐ",
        sort: true,
        type: "string",
        field: "status",
        formatter: cell => (
          <BagdeStatus
            titleBadge={
              cell === "effective"
                ? "Đang hiệu lực"
                : cell === "completed"
                ? "Đã thanh lý"
                : cell === "early-settled"
                ? "Đã tất toán sớm"
                : cell === "pending"
                ? "Đang xử lý"
                : cell === "canceled"
                ? "Đã huỷ"
                : ""
            }
            typeBadge={cell}
          />
        ),
        disableSearch: true,
      },
      {
        text: "Giá trị HĐ",
        sort: true,
        type: "string",
        field: "total",
        formatter: cell => <span>{formatNumber(cell)} VNĐ</span>,
        disableSearch: true,
      },
      {
        text: "Số kỳ",
        sort: true,
        type: "string",
        field: "noPeriods",
        formatter: cell => <span>{cell} tháng</span>,
        disableSearch: true,
      },
      {
        text: "Nơi đầu tư",
        sort: true,
        type: "string",
        field: "investment",
      },
      {
        text: "Ngày hết hạn HĐ",
        field: "endDate.iso",
        type: "string",
        sort: true,
        formatter: cell => <span>{moment(cell).format("DD/MM/YYYY")}</span>,
        disableSearch: true,
      },
      {
        text: "Họ và tên",
        field: "customer.fullName",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
      {
        text: "SĐT",
        field: "customer.phone",
        type: "model",
        modelNames: ["Customer"],
        sort: true,
      },
    ],
  },

  ExamSession: {
    columns: [
      {
        text: "Đã hoàn thành",
        sort: true,
        type: "boolean",
        field: "isCompleted",
        formatter: cell => {
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          );
        },
        searchOptions: "examSessionComplete",
      },
      {
        text: "Đạt",
        sort: true,
        type: "boolean",
        field: "isPassed",
        formatter: cell => {
          return (
            <input
              className="form-check-input"
              type="checkbox"
              style={{
                width: "15px",
                height: "15px",
                borderRadius: "10px",
                border: "1px solid black",
                backgroundColor: cell ? "green" : "white",
              }}
              disabled
              checked={cell}
            />
          );
        },
        searchOptions: "examSessionPass",
      },
      {
        text: "Ngày thi",
        sort: true,
        type: "string",
        field: "createdAt",
        formatter: cell => (
          <span>
            {cell
              ? moment(new Date(cell)).add(7, "hours").format("DD-MM-YYYY")
              : ""}
          </span>
        ),
        disableSearch: true,
      },
      {
        text: "Thời gian bắt đầu",
        sort: true,
        type: "string",
        field: "startTime",
        formatter: cell => (
          <span>{cell ? moment(cell?.iso).format("HH:mm:ss") : ""}</span>
        ),
        disableSearch: true,
      },
      {
        text: "Thời gian kết thúc",
        sort: true,
        type: "string",
        field: "endTime",
        formatter: cell => (
          <span>{cell ? moment(cell?.iso).format("HH:mm:ss") : ""}</span>
        ),
        disableSearch: true,
      },
      {
        text: "CCCD/CMND",
        sort: true,
        type: "string",
        field: "username",
      },
      {
        text: "SĐT",
        sort: true,
        type: "string",
        field: "phone",
      },
      {
        text: "Mã lớp",
        sort: true,
        type: "string",
        field: "class",
      },
    ],
  },
  HistoryLogin: {
    modelName: "UseAppHistory",
    include: ["user"],
    columns: [
      {
        text: "Tên đăng nhập (cmnd/cccd)",
        field: "user.username",
        type: "model",
        modelNames: ["_User"],
      },
      {
        text: "Số điện thoại",
        field: "user.phone",
        type: "model",
        modelNames: ["_User"],
      },
      {
        text: "Tên thiết bị",
        field: "device",
        type: "string",
      },
      {
        text: "Ngày truy cập",
        field: "createdAt",
        type: "date",
        formatter: cell => <span>{moment(cell).format("DD-MM-YYYY")}</span>,
      },
      {
        text: "Giờ truy cập",
        field: "createdAt",
        type: "date",
        formatter: cell => <span>{moment(cell).format("HH:mm")}</span>,
      },
    ],
  },
  TrainingCategory: {
    routingField: "objectId",
    columns: [
      {
        text: "Tên chương trình",
        field: "title",
        type: "string",
      },
      {
        text: "ảnh",
        field: "thumbnail.url",
        type: "model",
      },
      {
        text: "Số thứ tự hiển thị",
        field: "order",
        type: "string",
      },
    ],
  },
  TrainingTemplate: {
    routingField: "objectId",
    include: ["trainingCategory"],
    columns: [
      {
        text: "Hạng mục đào tạo",
        field: "trainingCategory.title",
        type: "model",
        modelNames: ["TrainingCategory"],
        disableSort: true,
      },
      {
        text: "Mã code",
        field: "code",
        type: "string",
        disableSort: true,
      },
      {
        text: "Tên tiêu đề",
        field: "title_vi",
        type: "string",
        disableSort: true,
      },
      {
        text: "Số lượng",
        field: "sessionNum",
        type: "string",
      },
      {
        text: "Loại",
        field: "sessionNumType",
        type: "string",
        disableSort: true,
      },

      {
        text: "Số thứ tự hiển thị",
        field: "order",
        type: "string",
      },
    ],
  },
  ProductContent: {
    routingPath: "/product-content/objectId",
    include: ["product"],
    columns: [
      {
        text: "Sản phẩm",
        field: "product.name",
        type: "model",
        modelNames: ["Product"],
      },
      {
        text: "Mô tả",
        field: "htmlText",
        type: "string",
        formatter: cell => (
          <>
            <div dangerouslySetInnerHTML={{ __html: cell }} />
          </>
        ),
      },
      {
        text: "Hình ảnh",
        field: "image.url",
        type: "model",
        formatter: cell => (
          <>
            {cell && (
              <img
                src={cell?.replace("phl.vvs.vn", "phl.live1.vn") || ""}
                style={{ objectFit: "cover", width: "64px" }}
              />
            )}
          </>
        ),
      },

      {
        text: "Số thứ tự hiển thị",
        field: "order",
        type: "string",
      },
    ],
  },

  Product: {
    routingField: "objectId",
    columns: [
      {
        text: "Tên",
        field: "name",
        type: "string",
      },
      {
        text: "Sắp xếp ảnh và mô tả theo",
        field: "templateType",
        type: "string",
        formatter: cell => {
          return <p>{cell == 1 ? "Chiều ngang" : "Chiều dọc"}</p>;
        },
      },
      {
        text: "Số thứ tự hiển thị chủ đề",
        field: "order",
        type: "string",
      },
    ],
  },
};
export default MODEL_CONFIG;
